import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class PFixOTTResponseMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_OTT_RESPONSE, fieldSet);
    }
    getExternalId() {
        return this.getFieldValue(FieldsFactory.FIELD_ID);
    }
    getOneTimeToken() {
        return this.getFieldValue(FieldsFactory.FIELD_ONE_TIME_TOKEN);
    }
}
